module.exports = __webpack_public_path__ + "img/icon_map_63_off_110.715b466e.png";